import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MAT_ERROR, MAT_FORM_FIELD, MatError, MatFormField } from '@angular/material/form-field';
import { TranslocoPipe } from '@jsverse/transloco';

/*
  This component overrides MatError so we can have an list of errors.
  Internally these handle simple error messages and server errors.
  It allows extra transcluded messages too :)
*/
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mat-error',
  templateUrl: './mat-error.component.html',
  providers: [{ provide: MAT_ERROR, useExisting: MatErrorOverrideComponent }],
  imports: [TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'mat-error',
  },
})
export class MatErrorOverrideComponent extends MatError {
  private formField = inject<MatFormField>(MAT_FORM_FIELD, { optional: true });

  public readonly required = input(false, { transform: booleanAttribute });
  public readonly labelText = input<string>();

  public get control(): AbstractControl | null | undefined {
    return this.formField?._control.ngControl?.control;
  }

  public get label(): string {
    const labelText = this.labelText();
    if (labelText) {
      return labelText;
    }

    const label = this.formField?.['_floatingLabel'];
    return label?.element?.querySelector('mat-label')?.textContent || '';
  }

  public hasError(error: string): boolean {
    return !!this.control?.hasError(error);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getError(error: string): any {
    const errors = this.control?.errors;

    return errors ? errors[error] : {};
  }
}
